@if (canBeEdited()) {
  <div class="row align-items-baseline mb-2">
    <h5 class="col-auto">{{ 'site' | translate }}</h5>
    <app-admin-site-selector [(model)]="addItem" [filters]="{ contractIsNull: true }" class="col" />
    <div class="col col-auto">
      <button class="btn btn-primary btn-sm" [disabled]="!addItem" (click)="add(addItem)">
        {{ 'Add' | translate }}
      </button>
    </div>
  </div>
}

<div class="row">
  <div class="col">
    <ngx-datatable
      class="data-table table-responsive task-list-table"
      [rows]="data?.content"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="50"
      [limit]="10"
      [rowHeight]="40"
    >
      <ngx-datatable-column [flexGrow]="2" name="host">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Host' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType"  let-row="row" ngx-datatable-cell-template>
          {{ row.domainName }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [flexGrow]="3" name="cluster">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Cluster' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.cluster.name }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [flexGrow]="3" name="organization">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Organization' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.owner.name }}
          <app-badge-organization [code]="row.owner.code"></app-badge-organization>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [flexGrow]="3" name="user">
        <ng-template let-column="column" ngx-datatable-header-template>
          {{ 'Utilisateur' | translate }}
        </ng-template>
        <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
          {{ row.owner.owner.email }}
        </ng-template>
      </ngx-datatable-column>
      @if (canBeEdited()) {
        <ngx-datatable-column [maxWidth]="40" name="actions" cellClass="actions">
          <ng-template let-column="column" ngx-datatable-header-template></ng-template>
          <ng-template [typedTemplate]="rowType" let-row="row" ngx-datatable-cell-template>
            <i
              title="{{ 'supprimer' | translate }}"
              (click)="remove(row)"
              style="color: #e74c3c"
              class="pointer icofont icofont-ui-delete"
            ></i>
          </ng-template>
        </ngx-datatable-column>
      }
      <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template>
          <app-table-pager [data]="data" [page]="page" (changePage)="changePage($event)" />
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</div>
